import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../../firebase';
import { AuctionProvider } from '../../context/AuctionContext';
import AppLayout from '../../components/AppLayout';
import { Box, CircularProgress, Alert } from '@mui/material';
import { page } from '../../theme/commonStyles';

function AuctionEnvironment() {
    const { auctionId } = useParams();
    const [auction, setAuction] = useState(null);
    const [seasonSpelfase, setSeasonSpelfase] = useState('');
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchAuction = async () => {
            if (!auctionId) {
                setLoading(false);
                setError('Geen veiling ID gevonden in de URL.');
                return;
            }
            try {
                const auctionSnap = await getDoc(doc(db, 'auctions', auctionId));
                if (!auctionSnap.exists()) {
                    setError('Deze veiling bestaat niet.');
                    setLoading(false);
                    return;
                }

                const auctionData = { id: auctionSnap.id, ...auctionSnap.data() };
                setAuction(auctionData);

                // Het seizoen zet de standaard spelfase; de veiling mag ervan
                // afwijken. Die standaard hoort dus hier opgehaald te worden, zodat
                // alle pagina's er via de context bij kunnen.
                if (auctionData.season) {
                    const seasonSnap = await getDoc(doc(db, 'seasons', String(auctionData.season)));
                    if (seasonSnap.exists()) {
                        setSeasonSpelfase(seasonSnap.data().spelfase || '');
                    }
                }
            } catch (err) {
                setError('Fout bij het ophalen van de veiling.');
                console.error(err);
            }
            setLoading(false);
        };

        fetchAuction();
    }, [auctionId]);

    if (loading) {
        return <Box sx={page.fullscreenLoadingContainer}><CircularProgress /></Box>;
    }

    if (error) {
        return <Alert severity="error">{error}</Alert>;
    }

    if (!auction) {
        return <Alert severity="warning">Veiling niet gevonden.</Alert>;
    }

    return (
        <AuctionProvider auction={auction} seasonSpelfase={seasonSpelfase}>
            <AppLayout />
        </AuctionProvider>
    );
}

export default AuctionEnvironment;
